import React, { useState, useEffect } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import {
  CardContent,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
  Stack,
} from "@mui/material";
import styled from "@emotion/styled";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import commonMessages from "../../utility/constant";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { getAuthToken } from "../../utility/tokenUtility";
import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { useNavigate } from "react-router-dom";

function WorkOrderStatus() {
  const StyledText = styled("text")(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 14,
    fontWeight: 600,
  }));

  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
      </StyledText>
    );
  }
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("schedule");
  const [scheduledClosedCount, setScheduledClosedCount] = useState(0);
  const [scheduledOpenCount, setScheduledOpenCount] = useState(0);
  const [scheduledInprogressCount, setScheduledInprogressCount] = useState(0);
  const [scheduledCompletedCount, setScheduledCompletedCount] = useState(0);
  const [unscheduledClosedCount, setUnscheduledClosedCount] = useState(0);
  const [unscheduledOpenCount, setUnscheduledOpenCount] = useState(0);
  const [unscheduledInprogressCount, setUnscheduledInprogressCount] = useState(0);
  const [unscheduledCompletedCount, setUnscheduledCompletedCount] = useState(0);


  const allMonths = commonMessages.months; // Assuming `commonMessages.months` is an array of month names.
  const all = { label: "All", value: "All", id: "0" };
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  const [year, setYear] = useState(() => {
    const initialYear = currentYear.toString();
    return { label: initialYear, value: initialYear };
  });

  const [month, setMonth] = useState(() => {
    const initialMonth =
      allMonths[currentMonthIndex]; // Default to current month if not in location.state            
    return initialMonth;
  });

  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);

  const fetchMaintenanceYears = async () => {
    const facilityid = localStorage.getItem("facilityId");
    try {
      const maintenanceYearResponse = await axios.get(
        `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`
      );
      const years = maintenanceYearResponse.data.items.map(year => ({
        label: year.maintyearvalue.toString(),
        value: year.maintyearvalue.toString(),
      }));
      setYearsOptions(years || []);
    } catch (error) {
      console.error('Error fetching maintenance years:', error);
    }
  };

  useEffect(() => {
    const selectedYear = parseInt(year.value);
    const isNextYear = currentMonthIndex === 11;

    const months =
      selectedYear === currentYear
        ? [
          all,
          ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
          // ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
        ]
        : [all, ...allMonths]; // All months for previous years

    setMonthsOptions(months);

    // if (!location?.state?.month) {

    setMonth(
      selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
    );
    // }
  }, [year]);

  const fetchtotalCount = async () => {
    try {
      const facilityid = localStorage.getItem("facilityId");
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Define the API endpoints
      const apiUrlFEMS = `${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountByFacilityIdWOStatusCount/${facilityid}/${month?.id}/${year?.value}`;
      const apiUrlBEMS = `${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountByFacilityIdWOStatusCount/${facilityid}/${month?.id}/${year?.value}`;

      // Fetch data from both endpoints simultaneously
      const [responseFEMS, responseBEMS] = await Promise.all([
        axios.get(apiUrlFEMS, config),
        axios.get(apiUrlBEMS, config),
      ]);

      // Extract counts from both responses
      const femsCounts = responseFEMS.data || 0;
      const bemsCounts = responseBEMS.data || 0;


      const scheduledClosedCount1 = (femsCounts.scheduledClosedCount || 0) + (bemsCounts.scheduledClosedCount || 0);
      const scheduledOpenCount1 = (femsCounts.scheduledOpenCount || 0) + (bemsCounts.scheduledOpenCount || 0);
      const scheduledInprogressCount1 = (femsCounts.scheduledInprogressCount || 0) + (bemsCounts.scheduledInprogressCount || 0);
      const scheduledCompletedCount1 = (femsCounts.scheduledCompletedCount || 0) + (bemsCounts.scheduledCompletedCount || 0);
      const unscheduledClosedCount1 = (femsCounts.unscheduledClosedCount || 0) + (bemsCounts.unscheduledClosedCount || 0);
      const unscheduledOpenCount1 = (femsCounts.unscheduledOpenCount || 0) + (bemsCounts.unscheduledOpenCount || 0);
      const unscheduledInprogressCount1 = (femsCounts.unscheduledInprogressCount || 0) + (bemsCounts.unscheduledInprogressCount || 0);
      const unscheduledCompletedCount1 = (femsCounts.unscheduledCompletedCount || 0) + (bemsCounts.unscheduledCompletedCount || 0);

      setScheduledClosedCount(scheduledClosedCount1);
      setScheduledOpenCount(scheduledOpenCount1);
      setScheduledInprogressCount(scheduledInprogressCount1);
      setScheduledCompletedCount(scheduledCompletedCount1);
      setUnscheduledClosedCount(unscheduledClosedCount1);
      setUnscheduledOpenCount(unscheduledOpenCount1);
      setUnscheduledInprogressCount(unscheduledInprogressCount1);
      setUnscheduledCompletedCount(unscheduledCompletedCount1);


    } catch (error) {
      //  console.error("Error fetching data", error);
    }
  };


  useEffect(() => {
    if (year && month) {

      fetchMaintenanceYears();
      fetchtotalCount();
    }
  }, [year, month]);

  const data = selectedValue === "schedule"
    ? [
      {
        value: scheduledClosedCount,
        label: (location) => location === 'tooltip' ? 'Closed' : `Closed (${scheduledClosedCount})`,
        color: "#5ECBAD",
      },
      {
        value: scheduledOpenCount,
        label: (location) => location === 'tooltip' ? 'New' : `New (${scheduledOpenCount})`,
        color: "#566C67",
      },
      {
        value: scheduledInprogressCount,
        label: (location) => location === 'tooltip' ? 'In Progress' : `In Progress (${scheduledInprogressCount})`,
        color: "#D6B24D",
      },
      {
        value: scheduledCompletedCount,
        label: (location) => location === 'tooltip' ? 'Completed' : `Completed (${scheduledCompletedCount})`,
        color: "#A77BCA",
      },
    ]
    : [
      {
        value: unscheduledClosedCount,
        label: (location) => location === 'tooltip' ? 'Closed' : `Closed (${unscheduledClosedCount})`,
        color: "#5ECBAD",
      },
      {
        value: unscheduledOpenCount,
        label: (location) => location === 'tooltip' ? 'New' : `New (${unscheduledOpenCount})`,
        color: "#566C67",
      },
      {
        value: unscheduledInprogressCount,
        label: (location) => location === 'tooltip' ? 'In Progress' : `In Progress (${unscheduledInprogressCount})`,
        color: "#D6B24D",
      },
      {
        value: unscheduledCompletedCount,
        label: (location) => location === 'tooltip' ? 'Completed' : `Completed (${unscheduledCompletedCount})`,
        color: "#A77BCA",
      },
    ];


  const handleYearChange = (newValue) => {
    if (newValue && newValue.value !== year?.value) {
      const selectedYear = parseInt(newValue.value);
      const currentDate = new Date();
      const currentMonthIndex = currentDate.getMonth();

      const months =
        selectedYear === currentYear
          ? [
            all,
            ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
            ...(currentMonthIndex === 11 ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
          ]
          : [all, ...allMonths]; // All months for previous years

      setYear(newValue); // Keep the selected year
      setMonthsOptions(months);
      setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]); // Default to the start of the year for future years
    }
  };

  const handleMonthChange = (newValue) => {
    setMonth(newValue);
  };


  return (
    <>
      <StyledCard variant="outlined">
        <CardContent>

          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              W.O Status
            </Typography>

            <Stack direction="row" alignItems="center" gap={1}>
              <CustomSelectInput
                fullWidth={false}
                labelSize="14px"
                sx={{ width: 100 }}
                label="Year"
                options={yearsOptions}
                value={year}
                onChange={handleYearChange}
                placeholder="Select Year"
                disableClearable
                highlight
              />
              <CustomSelectInput
                fullWidth={false}
                labelSize="14px"
                sx={{ width: 100 }}
                label="Month"
                options={monthsOptions}
                value={month}
                onChange={handleMonthChange}
                placeholder="Select Month"
                disableClearable
                disabled={!year}
                highlight
              />
            </Stack>
          </Stack>

          <Box>
            <RadioGroup
              row
              aria-labelledby="work-order-chart"
              name="work-order-chart"
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}
            >
              <FormControlLabel
                value="schedule"
                control={<Radio size="small" />}
                label="Schedule"
              />
              <FormControlLabel
                value="unschedule"
                control={<Radio size="small" />}
                label="Unschedule"
              />
            </RadioGroup>
          </Box>
          <Box width={"100%"}>
            <PieChart
              onItemClick={(event, d) => navigate("/workorder", { state: { year: year?.value,  month: { value: month?.value, label: month?.label, id: month?.id }} } )}
              sx={{
                "& .MuiChartsTooltip-root": {
                  "& .MuiTypography-root": {
                    color: "black", // Set font color to black
                  },
                },
              }}
              series={[
                {
                  data: data,
                  innerRadius: 70,
                  outerRadius: 90,
            
                },
              ]}
              height={300}
              slotProps={{
                
                legend: {
                  direction: "row",
                  position: { vertical: "bottom", horizontal: "center" },
                  padding: 0,
                  itemMarkWidth: 15,
                  itemMarkHeight: 15,
                  markGap: 5,
                  itemGap: 16,
                  labelStyle: {
                    fontSize: 12,
                    color: "text.primary",
                    fontWeight: 400,
                  },
                },
              }}
              margin={{
                left: 60,
                bottom: 60,
              }}
            >
              <PieCenterLabel>Total Work Order</PieCenterLabel>
            </PieChart>
          </Box>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default WorkOrderStatus;
